require('../../modules/es6.object.is');
module.exports = require('../../modules/_core').Object.is;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/fn/object/is.js
// module id = ./node_modules/core-js/library/fn/object/is.js
// module chunks = 6